import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IdPErrorViewComponent } from './view/idp-error-view/idp-error-view.component';
import { AuthenticationContextDatasourceService } from '../backend/datasource/authentication-context-datasource.service';

@NgModule({
  imports: [BrowserModule, IdPErrorViewComponent],
  providers: [AuthenticationContextDatasourceService]
})
export class RootModule {}
